<div class="container-fluid pb-4">
    <div class="row justify-content-between manageaccount mt-3">
        <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
            <div class="d-flex align-items-baseline justify-content-between">
                <h1 class="fs-4 fw-bold mb-0">View Invoice ({{ isAdHoc ? 'Ad Hoc' : 'Fixed' }})</h1>
                <button class="btn btn-dark btn-sm" matTooltip="Back" matTooltipPosition="left" mat-raised-button
                    (click)="backTo()"><i class="fa-solid fa-arrow-left"></i></button>
            </div>
            <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">Manage LR</li>
                    <li class="breadcrumb-item active" aria-current="page">View Invoice </li>
                </ol>
            </nav>
        </div>
    </div>

    <!-- ================= TYPE 1 / AD HOC (Matches DB 'Type1' & 'Ad Hoc') ================= -->
    <div class="row mt-3" *ngIf="isAdHoc">
        <div class="col-xl-12">
            <div class="contentbox">
                <div class="row align-items-center mb-3">
                    <div class="col-12 text-end d-flex justify-content-end align-items-center gap-2">
                        <!-- <button mat-raised-button class="btn btn-outline-dark btn-sm px-4" [useExistingCss]="true" printSectionId="print-section" >Print</button>&nbsp; -->
                        <button *ngIf="paramId" routerLink="../../gst-invoice/{{this.paramId}}" mat-raised-button
                            class="btn btn-dark btn-sm px-4">GST Invoice</button>&nbsp;
                        <button mat-raised-button class="btn btn-dark btn-sm px-4"
                            (click)="sendInvoice('print-section')">Email</button>
                        <!-- <ng-container *ngIf="!isEditing">
                            <button class="btn btn-outline-dark btn-sm" mat-stroked-button (click)="enableEdit()">Edit</button>
                        </ng-container> -->
                        <!-- <ng-container *ngIf="isEditing">
                            <button class="btn btn-success btn-sm" mat-raised-button (click)="saveEdit()"
                                [disabled]="isSaving">
                                <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
                                Save
                            </button>
                            <button class="btn btn-outline-secondary btn-sm" mat-stroked-button (click)="cancelEdit()"
                                [disabled]="isSaving">Cancel</button>
                        </ng-container> -->
                    </div>
                </div>

                <div class="NewInvoice table-responsive" id="print-section">
                    <table class="newInvoiceBox">
                        <tr>
                            <td class="py-3">
                                <table class="invoiceHead">
                                    <tr>
                                        <td>Transporter Name </td>
                                        <td>: {{ transporterName || 'Radha Swami' }}</td>
                                    </tr>
                                    <tr>
                                        <td> Company</td>
                                        <td>: {{ companyName || 'S 11 Block B, Sector-5, Sahni Tower, Rajender Nagar, Sahibabad, Ghaziabad, Ghaziabad, Uttar Pradesh – 201005' }}</td>
                                    </tr>
                                    <tr *ngIf="transporterAddress && transporterAddress !== 'N/A'">
                                        <td>Address</td>
                                        <td>: {{ transporterAddress }}</td>
                                    </tr>
                                    <tr *ngIf="transporterGstNo && transporterGstNo !== 'N/A'">
                                        <td>GST Number</td>
                                        <td>: {{ transporterGstNo }}</td>
                                    </tr>
                                    <tr>
                                        <td>Bill No </td>
                                        <td>: {{ billno }}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td>Location</td>
                                        <td>: Shahdara</td>
                                    </tr>
                                    <tr>
                                        <td>Type of Vehicle </td>
                                        <td>: ECCO</td>
                                    </tr>
                                    <tr>
                                        <td>Vehicle No</td>
                                        <td>: DL1V7320</td>
                                    </tr> -->
                                </table>
                            </td>
                            <td class="text-end py-3">
                                <img src="../../../../assets/images/invoiceLogoDemo.png" width="200" alt="">
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <table class="invoiceDetails" *ngIf="users && users.length > 0">
                                    <thead>
                                        <!-- AD Hoc Header (with Manual LR No. restored) -->
                                        <tr *ngIf="isAdHoc">
                                            <td>Date</td>
                                            <td>System LR No.</td>
                                            <!-- <td>Manual LR No.</td> -->
                                            
                                            <td>VEHICLE NO:</td>
                                            <td>VEHICLE TYPE</td>
                                            <td>From</td>
                                            <td>TO</td>
                                            <td>Freight</td>
                                            <td>LABOUR LOADING</td>
                                            <td>LABOUR UNLOADING</td>
                                            <td>OTHER PAYMENTs</td>
                                            <td>Detention</td>
                                            <!-- <td>Toll & Parking</td> -->
                                            <td>FINAL AMOUNT</td>
                                        </tr>

                                        <!-- Legacy / Fixed Header (with Manual LR No. and reading columns restored) -->
                                        <tr *ngIf="!isAdHoc">
                                            <td>Date</td>
                                            <td>System LR No.</td>
                                            <td>Manual LR No.</td>
                                            
                                            <td>VEHICLE NO:</td>
                                            <td>VEHICLE TYPE</td>
                                            <td>From</td>
                                            <td>TO</td>
                                            <td>Freight</td>
                                            <td>START READING</td>
                                            <td>END.READING</td>
                                            <td>KMR.</td>
                                            <td>EXTRA HRS</td>
                                            <td>Toll & Parking</td>
                                            <td>AMOUNT</td>
                                        </tr>
                                    </thead>

                                    <tbody *ngFor="let user of users; let uIndex = index">
                                        <!-- AD Hoc Rows -->
                                        <ng-container *ngIf="isAdHoc">
                                            <tr *ngFor="let lr of user.LR_no; let i = index">
                                                <td>{{ user.date[i] | date }}</td>
                                                <td>{{ user.LR_no[i] }}</td>
                                                <!-- <td>{{ user.manualLR_no?.[i] || '-' }}</td> -->
                                                
                                                <td>{{ user.vehicle_id[i] }}</td>
                                                <td>{{ getVehicleType(user, i) }}</td>
                                                <td>{{ user.from[i] }}</td>
                                                <td>{{ user.to[i] }}</td>
                                                <td>{{ getFreight(user, i) }}</td>
                                                <td>
                                                    <span *ngIf="!isEditing">{{ (user.labourLoad && user.labourLoad[i] != null && user.labourLoad[i] !== '') ? user.labourLoad[i] : '-' }}</span>
                                                    <input *ngIf="isEditing" type="number" min="0"
                                                        class="form-control form-control-sm table-input"
                                                        [(ngModel)]="user.labourLoad[i]"
                                                        (input)="recalculateTotals()" />
                                                </td>
                                                <td>
                                                    <span *ngIf="!isEditing">{{ (user.labourUnload && user.labourUnload[i] != null && user.labourUnload[i] !== '') ? user.labourUnload[i] : '-' }}</span>
                                                    <input *ngIf="isEditing" type="number" min="0"
                                                        class="form-control form-control-sm table-input"
                                                        [(ngModel)]="user.labourUnload[i]"
                                                        (input)="recalculateTotals()" />
                                                </td>
                                                <td>{{ user.otherPayment[i] }}</td>
                                                <td>
                                                    <span *ngIf="!isEditing">{{ (user.detention && user.detention[i] != null && user.detention[i] !== '') ? user.detention[i] : '-' }}</span>
                                                    <input *ngIf="isEditing" type="number" min="0"
                                                        class="form-control form-control-sm table-input"
                                                        [(ngModel)]="user.detention[i]"
                                                        (input)="recalculateTotals()" />
                                                </td>
                                                <!-- <td>{{ user.tooltaxPaid[i] }}</td> -->
                                                <td>{{ getAdhocLineAmount(user, i) | number:'1.2-2' }}</td>
                                            </tr>

                                            <tr>
                                                <td class="footer">TOTAL</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <!-- <td class="footer">&nbsp;</td> -->
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">{{ totLabourLoad | number:'1.2-2' }}</td>
                                                <td class="footer">{{ totLabourUnload | number:'1.2-2' }}</td>
                                                <td class="footer">{{ otherPayment | number:'1.2-2' }}</td>
                                                <td class="footer">{{ totDetention | number:'1.2-2' }}</td>
                                                <!-- <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td> -->
                                                <td class="footer">{{ totalAmountInAdhoc | number:'1.2-2' }}</td>
                                            </tr>

                                            <!-- <tr>
                                                <td colspan="9"></td>
                                                <td colspan="5" class="p-0">
                                                    <table class="extraText">
                                                        <tr>
                                                            <td>Total KM={{ kmtot }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Detention={{ totDetention }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Labour Loading={{ totLabourLoad }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Labour Unloading={{ totLabourUnload }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Toll & Parking={{ tooltaxPaidtot }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total={{ totalAmountInAdhoc | number:'1.2-2' }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr> -->
                                        </ng-container>

                                        <!-- Legacy / Fixed Rows -->
                                        <ng-container *ngIf="!isAdHoc">
                                            <tr *ngFor="let lr of user.LR_no; let i = index">
                                                <td>{{ user.date[i] | date }}</td>
                                                <td>{{ user.LR_no[i] }}</td>
                                                <td>{{ user.manualLR_no?.[i] || '-' }}</td>
                                                <td>{{ getFreight(user, i) }}</td>
                                                <td>{{ user.vehicle_id[i] }}</td>
                                                <td>{{ getVehicleType(user, i) }}</td>
                                                <td>{{ user.from[i] }}</td>
                                                <td>{{ user.to[i] }}</td>
                                                <td>{{ user.startmeterReading[i] }}</td>
                                                <td>{{ user.endmeterReading[i] }}</td>
                                                <td>{{ user.up_down_km[i] }}</td>
                                                <td>{{ user.extrahour[i] }}</td>
                                                <td>{{ user.tooltaxPaid[i] }}</td>
                                                <td>{{ user.vehicleRate[i] }}</td>
                                            </tr>

                                            <tr>
                                                <td class="footer">TOTAL</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">&nbsp;</td>
                                                <td class="footer">{{ kmtot | number:'1.2-2' }}</td>
                                                <td class="footer">{{ extrahour | number:'1.2-2' }}</td>
                                                <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
                                                <td class="footer">{{ invtot | number:'1.2-2' }}</td>
                                            </tr>

                                            <tr>
                                                <td colspan="9"></td>
                                                <td colspan="5" class="p-0">
                                                    <table class="extraText">
                                                        <tr>
                                                            <td>Total KM={{ kmtot }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Extra Hours={{ extrahour }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Toll & Parking={{ tooltaxPaidtot }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total={{ invtot | number:'1.2-2' }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </ng-container>

                                        <tr>
                                            <td colspan="14"><b>{{ totalAmountInAdhoc | amountInWords }}</b></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Dummy Preview Table (Restored from commit 00f24398) -->
                                <table class="invoiceDetails" hidden>
                                    <thead>
                                        <tr>
                                            <td>Date</td>
                                            <td>Opening Reading </td>
                                            <td>Closing Reading</td>
                                            <td>Total KM</td>
                                            <td>Start Time</td>
                                            <td>End Time </td>
                                            <td>Total Hours</td>
                                            <td>Destination/Route</td>
                                            <td>Toll </td>
                                            <td> Parking</td>
                                            <td>Value of Total Invoices</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>&nbsp;</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>6</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>230</td>
                                            <td>&nbsp;</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>&nbsp;</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>&nbsp;</td>
                                            <td>40</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td class="footer">TOTAL</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">3997</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">65</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">2370</td>
                                            <td class="footer">1700</td>
                                            <td class="footer">2182563</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <p>We hereby confirmed that all the LR copies duly acknowledged by the customers have
                                    been received and above details are found correct.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="signature">
                                    <tr>
                                        <td>
                                            <p>Prepaired By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                        <td>
                                            <p>Verified By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                        <td>
                                            <p>Approved By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- ================= TYPE 2 / FIXED (Matches DB 'Type2' & 'Fixed') ================= -->
    <div class="row mt-3" *ngIf="!isAdHoc">
        <div class="col-xl-12">
            <div class="contentbox">
                <div class="text-center">
                    <!-- <button mat-raised-button class="btn btn-outline-dark btn-sm px-4" [useExistingCss]="true" printSectionId="print-section" >Print</button>&nbsp; -->
                    <button *ngIf="paramId" routerLink="../../gst-invoice/{{this.paramId}}" mat-raised-button
                        class="btn btn-dark btn-sm px-4">GST Invoice</button>&nbsp;
                    <button mat-raised-button class="btn btn-dark btn-sm px-4"
                        (click)="sendInvoice('print-section-2')">Email</button>
                </div>
                <div class="NewInvoice table-responsive" id="print-section-2">
                    <table class="newInvoiceBox">
                        <tr>
                            <td class="py-3">
                                <table class="invoiceHead">
                                    <tr>
                                        <td>Transporter Name </td>
                                        <td>: {{ (transporterName && transporterName !== 'Radha Swami Transport Service' && transporterName !== 'Radha Swami') ? transporterName : 'Whirlpool PVT LTD' }}</td>
                                    </tr>
                                    <tr *ngIf="transporterAddress && transporterAddress !== 'N/A'">
                                        <td>Address</td>
                                        <td>: {{ transporterAddress }}</td>
                                    </tr>
                                    <tr *ngIf="transporterGstNo && transporterGstNo !== 'N/A'">
                                        <td>GST Number</td>
                                        <td>: {{ transporterGstNo }}</td>
                                    </tr>
                                    <tr>
                                        <td>Bill No </td>
                                        <td>: {{ billno }}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td>Location</td>
                                        <td>: Shahdara</td>
                                    </tr>
                                    <tr>
                                        <td>Type of Vehicle </td>
                                        <td>: ECCO</td>
                                    </tr>
                                    <tr>
                                        <td>Vehicle No</td>
                                        <td>: DL1V7320</td>
                                    </tr> -->
                                </table>
                            </td>
                            <td class="text-end py-3">
                                <img src="../../../../assets/images/invoiceLogoDemo.png" width="200" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="invoiceDetails" *ngIf="users && users.length > 0">
                                    <thead>
                                        <tr>
                                            <td>Date</td>
                                            <td>System LR No.</td>
                                            <td>Manual LR No.</td>
                                            <td>Freight</td>
                                            <td>VEHICLE NO:</td>
                                            <td>VEHICLE TYPE</td>
                                            <td>From</td>
                                            <td>TO</td>
                                            <td>START READING</td>
                                            <td>END.READING</td>
                                            <td>KMR.</td>
                                            <td>EXTRA HRS</td>
                                            <td>Toll & Parking</td>
                                            <td>AMOUNT</td>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let user of users; let j=index">
                                        <tr *ngFor="let item of user.LR_no; let i=index">
                                            <td>{{ user.date[i] | date }}</td>
                                            <td>{{ user.LR_no[i] }}</td>
                                            <td>{{ user.manualLR_no?.[i] || '-' }}</td>
                                            <td>{{ getFreight(user, i) }}</td>
                                            <td>{{ user.vehicle_id[i] }}</td>
                                            <td>{{ getVehicleType(user, i) }}</td>
                                            <td>{{ user.from[i] }}</td>
                                            <td>{{ user.to[i] }}</td>
                                            <td>{{ user.startmeterReading[i] }}</td>
                                            <td>{{ user.endmeterReading[i] }}</td>
                                            <td>{{ user.up_down_km[i] }}</td>
                                            <td>{{ user.extrahour[i] }} </td>
                                            <td>{{ user.tooltaxPaid[i] }}</td>
                                            <td>{{ user.vehicleRate[i] }}</td>
                                        </tr>

                                        <tr>
                                            <td class="footer">TOTAL</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">{{ kmtot | number:'1.2-2' }}</td>
                                            <td class="footer">{{ extrahour | number:'1.2-2' }}</td>
                                            <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
                                            <td class="footer">{{ invtot | number:'1.2-2' }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="9"></td>
                                            <td colspan="5" class="p-0">
                                                <table class="extraText">
                                                    <tr>
                                                        <td>Total KM={{ kmtot }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Extra Hours={{ extrahour }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Toll & Parking={{ tooltaxPaidtot }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total={{ invtot | number:'1.2-2' }}</td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="14"><b>{{ invtot | amountInWords }}</b></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- Dummy Preview Table (Restored from commit 00f24398) -->
                                <table class="invoiceDetails" hidden>
                                    <thead>
                                        <tr>
                                            <td>Date</td>
                                            <td>Opening Reading </td>
                                            <td>Closing Reading</td>
                                            <td>Total KM</td>
                                            <td>Start Time</td>
                                            <td>End Time </td>
                                            <td>Total Hours</td>
                                            <td>Destination/Route</td>
                                            <td>Toll </td>
                                            <td> Parking</td>
                                            <td>Value of Total Invoices</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>&nbsp;</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>6</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>230</td>
                                            <td>&nbsp;</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td>01.11.2019</td>
                                            <td>165690</td>
                                            <td>165732</td>
                                            <td>42</td>
                                            <td>06.00AM</td>
                                            <td>12.00PM </td>
                                            <td>&nbsp;</td>
                                            <td>CANNAUGHT PLACE</td>
                                            <td>&nbsp;</td>
                                            <td>40</td>
                                            <td>12573</td>
                                        </tr>
                                        <tr>
                                            <td class="footer">TOTAL</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">3997</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">65</td>
                                            <td class="footer">&nbsp;</td>
                                            <td class="footer">2370</td>
                                            <td class="footer">1700</td>
                                            <td class="footer">2182563</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <p>We hereby confirmed that all the LR copies duly acknowledged by the customers have
                                    been received and above details are found correct.
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="signature">
                                    <tr>
                                        <td>
                                            <p>Prepaired By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                        <td>
                                            <p>Verified By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                        <td>
                                            <p>Approved By</p>
                                            <p>Name</p>
                                            <p>Designation</p>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>